<mlp-ng-icon name="check-circle-1" class="xlarge"></mlp-ng-icon>
